import { Col } from "antd";
import { useTranslation } from "react-i18next";

const HeaderText = () => {
  const { t } = useTranslation();
  return (
    <Col xl={16} lg={14} className="hp-header-left-text hp-d-flex-center">
      <svg
        width="18px"
        height="18px"
        style={{
          marginRight: "8px",
        }}
        className="remix-icon"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="24" cy="24" r="21" fill="#2196F3" />
        <path fill="#fff" d="M22 22h4v11h-4z" />
        <circle cx="24" cy="16.5" r="2.5" fill="#fff" />
      </svg>

      <p className="hp-header-left-text-item hp-input-label hp-text-color-black-100 hp-text-color-dark-0 hp-ml-16 hp-mb-0">
        <span className="hp-font-weight-500 hp-text-color-danger-1">
          {t("headerBar.contactUs")}👉
        </span>
        <a
          href="https://discord.gg/USz9MNW2Ed"
          className="hp-text-color-black-80"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            marginLeft: "0.5rem",
          }}
        >
          <svg
            width="20px"
            height="20px"
            className="remix-icon"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#3b82f6"
              d="M18.72 14.76c.35-.85.54-1.76.54-2.76c0-.72-.11-1.41-.3-2.05c-.65.15-1.33.23-2.04.23A9.07 9.07 0 0 1 9.5 6.34a9.21 9.21 0 0 1-4.73 4.88c-.04.25-.04.52-.04.78A7.27 7.27 0 0 0 12 19.27c1.05 0 2.06-.23 2.97-.64c.57 1.09.83 1.63.81 1.63c-1.64.55-2.91.82-3.78.82c-2.42 0-4.73-.95-6.43-2.66a9.03 9.03 0 0 1-2.24-3.69H2v-4.55h1.09a9.09 9.09 0 0 1 15.33-4.6a8.991 8.991 0 0 1 2.47 4.6H22v4.55h-.06L18.38 18l-5.3-.6v-1.67h4.83l.81-.97m-9.45-2.99c.3 0 .59.12.8.34a1.136 1.136 0 0 1 0 1.6c-.21.21-.5.33-.8.33c-.63 0-1.14-.5-1.14-1.13c0-.63.51-1.14 1.14-1.14m5.45 0c.63 0 1.13.51 1.13 1.14c0 .63-.5 1.13-1.13 1.13c-.63 0-1.14-.5-1.14-1.13a1.14 1.14 0 0 1 1.14-1.14Z"
            />
          </svg>
        </a>
      </p>
    </Col>
  );
};

export default HeaderText;
